import React from 'react';
import { Link } from 'react-router-dom';

const Privacypolicy = () => {
  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* inner-page hero start */}
      <div 
        className="inner-page-hero" 
        style={{ backgroundImage: 'url(/assets/images/background/bg3.png)' }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>Privacy-Policy</h2>
          </div>
          <ul className="bradcrumb">
            <li><a href="/">Home</a></li>
            <li><Link to="#">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>
      {/* inner-page hero end */}

      {/* --- MAIN CONTENT --- */}
      <section className="privacy-section">
        <div className="container">
          <div className="row justify-content-center">
            
            <div className="col-lg-12">
              <div className="privacy-content-card">
                
                {/* Header Block */}
                  <div className=" mb-5 text-center">
            <span className="heading-subtitle wow fadeInUp animated">⭐ Privacy Policy</span>
            <h2 className="wow fadeInUp animated">Wall Street Finz — Privacy Policy</h2>
          
                  <div className="meta-info-box">
                    <p><strong>Effective Date:</strong> Immediately upon publication</p>
                    <p><strong>Owned & Operated By:</strong> Wall Street Merchants Pvt Ltd.</p>
                  </div>
                  <p className="intro-text mt-4">
                    Your privacy matters to us. This Privacy Policy explains how <strong>Wall Street Finz</strong> (“Company”, “We”, “Us”) collects, uses, stores, shares, and protects your information when you use our website to apply for financial services. By accessing our Platform, you consent to the practices described in this Policy.
                  </p>
                </div>

                <hr className="divider" />

                {/* 1. Information We Collect */}
                <div className="policy-block" id="collect">
                  <h3>1. Information We Collect</h3>
                  <p>We collect information to verify your identity, assess loan eligibility, and provide services efficiently.</p>
                  
                  <div className="info-grid">
                    {/* Card A */}
                    <div className="info-card">
                      <div className="icon-box"><i className="flaticon-personalization"></i></div>
                      <h4>A. Personal Information</h4>
                      <ul>
                        <li>Full Name</li>
                        <li>Date of Birth</li>
                        <li>Address & Contact Details</li>
                        <li>Email & Phone Number</li>
                        <li>PAN, Aadhaar, Voter ID (KYC)</li>
                        <li>Photograph & Selfie verification</li>
                      </ul>
                    </div>

                    {/* Card B */}
                    <div className="info-card">
                      <div className="icon-box"><i className="flaticon-money-bag"></i></div>
                      <h4>B. Financial Information</h4>
                      <ul>
                        <li>Bank account number, IFSC</li>
                        <li>Income details & Statements</li>
                        <li>Employment information</li>
                        <li>Credit score history</li>
                      </ul>
                    </div>

                    {/* Card C */}
                    <div className="info-card">
                      <div className="icon-box"><i className="flaticon-settings"></i></div>
                      <h4>C. Device & Technical Data</h4>
                      <ul>
                        <li>IP address</li>
                        <li>Device model, OS version</li>
                        <li>Network information</li>
                        <li>App usage patterns</li>
                        <li>Cookies & tracking data</li>
                      </ul>
                    </div>
                  </div>
                  <p className="small text-muted mt-2">* We collect only what is necessary and permitted under law.</p>
                </div>

                {/* 2. How We Use */}
                <div className="policy-block">
                  <h3>2. How We Use Your Information</h3>
                  <p>Your data helps us provide secure and fast financial services. We use it for:</p>
                  <ul className="check-list">
                    <li>Identity verification (KYC)</li>
                    <li>Loan eligibility checks & Risk scoring</li>
                    <li>Processing loan applications & Disbursements</li>
                    <li>Fraud detection and prevention</li>
                    <li>Customer support & Legal compliance</li>
                  </ul>
                  <div className="alert-box warning">
                    <i className="flaticon-security"></i> <strong>Note:</strong> We do NOT sell your personal information.
                  </div>
                </div>

                {/* 3. Sharing */}
                <div className="policy-block">
                  <h3>3. Sharing Your Information</h3>
                  <p>We may share your data <strong>ONLY</strong> with:</p>
                  <ul className="dot-list">
                    <li>Registered NBFCs/Banks for loan approval</li>
                    <li>Credit bureaus (CIBIL, Experian, etc.)</li>
                    <li>KYC verification agencies</li>
                    <li>Payment gateways for EMI processing</li>
                    <li>Service providers assisting with technology & support</li>
                    <li>Law enforcement, when legally required</li>
                  </ul>
                  <p className="mt-2">All partners follow strict confidentiality obligations.</p>
                </div>

                {/* 4. Storage & Security */}
                <div className="policy-block">
                  <h3>4. Storage & Security</h3>
                  <p>We use strong security measures to protect your data:</p>
                  <div className="security-features">
                    <span className="sec-tag"><i className="flaticon-padlock"></i> Encryption (at rest & transit)</span>
                    <span className="sec-tag"><i className="flaticon-server"></i> Secure Servers</span>
                    <span className="sec-tag"><i className="flaticon-eye"></i> Regular Audits</span>
                    <span className="sec-tag"><i className="flaticon-check"></i> OTP-based Access</span>
                  </div>
                  <p className="mt-3">We keep your information only as long as needed for legal and operational purposes.</p>
                </div>

                {/* 5. Your Rights */}
                <div className="policy-block">
                  <h3>5. Your Rights</h3>
                  <p>You may request access, correction, or deletion of your data. You can also withdraw consent for non-essential services.</p>
                  <p>For such requests, email us at: <a href="mailto:info@wallstreetfinz.com" className="link-text">info@wallstreetfinz.com</a></p>
                </div>

                {/* 6. Cookies */}
                <div className="policy-block">
                  <h3>6. Cookies & Tracking</h3>
                  <p>We use cookies to improve user experience, remember sessions, and prevent fraud. You may disable cookies in your browser settings.</p>
                </div>

                {/* 7. Third Party Links & Children */}
                <div className="policy-block">
                  <h3>7. Third-Party Links & Children's Privacy</h3>
                  <p>Our Platform may contain links to external websites. We are not responsible for their content or privacy practices.</p>
                  <p>Our services are not intended for minors under 18. We do not knowingly collect data from children.</p>
                </div>

                {/* 8. Changes */}
                <div className="policy-block">
                  <h3>9. Changes to This Policy</h3>
                  <p>We may update this Policy periodically. Continued use of the Platform means you accept the updated terms.</p>
                </div>

                {/* 10. Contact */}
                <div className="contact-block">
                  <h3>Contact Us</h3>
                  <p>For questions, concerns, or requests related to privacy:</p>
                  <div className="contact-details">
                    <div className="contact-row">
                        <i className="flaticon-email"></i>
                        <a href="mailto:info@wallstreetfinz.com">info@wallstreetfinz.com</a>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
  

       

    </>
  );
};

export default Privacypolicy;